(() => {
  const SOURCE_SELECTORS = ['[id^="visual_timer_wrapper"] .dt-vt-est', '.dt-vt-est'];
  const SOURCE_ROW_SELECTOR = ':scope > div';
  const COUNTRY_LABEL_ID = 'dlt_cname_label';

  const isRenderedNode = (element) => element.getClientRects().length > 0;

  const signatureOf = (element) => element.textContent.replace(/\s+/g, ' ').trim();

  if (customElements.get('delivery-timer-mirror')) return;

  customElements.define(
    'delivery-timer-mirror',
    class DeliveryTimerMirror extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-delivery-mirror-content]');
        if (!this.content) return;

        this.signature = null;
        this.observedSource = null;
        this.requestSync = this.requestSync.bind(this);

        this.sourceObserver = new MutationObserver(this.requestSync);
        this.documentObserver = new MutationObserver(this.requestSync);

        window.addEventListener('resize', this.requestSync, { passive: true });
        window.addEventListener('load', this.requestSync);

        this.documentObserver.observe(document.body, { childList: true, subtree: true });

        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.requestSync);
        window.removeEventListener('load', this.requestSync);
        if (this.sourceObserver) this.sourceObserver.disconnect();
        if (this.documentObserver) this.documentObserver.disconnect();
        if (this.syncFrame) cancelAnimationFrame(this.syncFrame);
      }

      resolveSourceRow() {
        for (const selector of SOURCE_SELECTORS) {
          const source = document.querySelector(selector);
          if (!source) continue;

          const row = source.querySelector(SOURCE_ROW_SELECTOR);
          if (row && isRenderedNode(row)) {
            this.observeSource(source);
            return row;
          }
        }

        return null;
      }

      observeSource(source) {
        if (this.observedSource === source) return;

        this.observedSource = source;
        this.sourceObserver.disconnect();
        this.sourceObserver.observe(source, {
          attributes: true,
          characterData: true,
          childList: true,
          subtree: true,
        });
      }

      requestSync() {
        if (this.syncFrame) return;

        this.syncFrame = requestAnimationFrame(() => {
          this.syncFrame = null;
          this.sync();
        });
      }

      sync() {
        if (!this.content) return;

        const row = this.resolveSourceRow();
        this.hidden = row === null;
        if (!row) return;

        const signature = signatureOf(row);
        if (signature === this.signature) return;

        this.signature = signature;
        this.content.replaceChildren(this.buildClone(row));
      }

      buildClone(row) {
        const clone = row.cloneNode(true);

        clone.style.justifyContent = 'flex-end';
        clone.style.gap = '8px';

        const country = clone.querySelector(`#${COUNTRY_LABEL_ID}`);
        if (country) {
          const column = Array.from(clone.children).find((child) => child.contains(country));
          (column || country).remove();
        }

        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));

        return clone;
      }
    }
  );
})();
